import { ConfigTabNav, type ConfigTabItem } from '@/components/layout/ConfigTabNav';

const tabs: ConfigTabItem[] = [
  {
    value: 'my-systems',
    labelKey: 'mySystems.title',
    to: '/$slug/systems',
    requiredPermission: { subject: 'MySystems' }
  },
  {
    value: 'landscape',
    labelKey: 'systemLandscape.title',
    to: '/$slug/systems/landscape',
    requiredPermission: { subject: 'SystemLandscape' }
  },
  {
    value: 'shadow-systems',
    labelKey: 'common.Sidebar.ShadowSystems',
    to: '/$slug/systems/shadow-systems',
    requiredPermission: { subject: 'ShadowSystem' }
  }
];

export function SystemTabsNav() {
  return <ConfigTabNav tabs={tabs} />;
}
